import React from 'react'
import HTag from '@/lib/HTag'
import Img from '@/lib/Img'
import clsx from 'clsx'

export default function HeroImage({ heading, image, disableCrop }) {
	return (
		<section className="bg-orange text-white">
			{!!heading?.text && (
				<header data-aos="fade-right" className="max-w-screen-xl mx-auto md:py-8 p-4 text-right">
					<HTag className="h1" {...heading} />
				</header>
			)}

			<Img
				data-aos="fade-left"
				className={clsx('w-full', !disableCrop && 'aspect-[2]')}
				image={image}
				alt={heading.text}
				draggable={false}
			/>
		</section>
	)
}
